const cart = {
    refresh() {
        return $.get('./ordering/cart/render')
            .then(cart => {
                $('#shopping-cart-container').html(cart);

                return $.get('./ordering/cart/render-header-shopping-cart');
            })
            .then(icon => {
                $('#shopping-cart-icon-container').html(icon);

                return $.get('./ordering/cart/render-header-shopping-cart-modal');
            })
            .done(modal => {
                $('#shopping-cart-modal-container').html(modal);
            });
    },
    refreshTable() {
        return $.get('./ordering/cart/render-table')
            .done(cart => {
                $('#shopping-cart-table-container').html(cart);
                $('[data-toggle="tooltip"]').tooltip();
            });
    },
    add(itemid, qty = 1, {
        versioningid = null,
        eventid = null,
        preview = null,
        refresh = true,
    } = {}) {
        return $.post('./ordering/cart/add', {
            itemid,
            qty,
            versioningid,
            eventid,
            preview,
            redirectTo: location.href,
        })
            .done(data => {
                if (data.fail && data.redirectTo) {
                    location.href = data.redirectTo;
                    return;
                }
                if (data.success) toast.success(`${data.message}     <strong><a class="text-body" href="./ordering/cart">View cart</a></strong>`);
                if (refresh) return cart.refresh();
            });
    },
    remove(itemid, {
        versioningid = null,
        eventid = null,
        refresh = true,
    } = {}) {
        return $.post('./ordering/cart/remove', {
            itemid,
            versioningid,
            eventid,
        })
            .done(data => {
                if (data.fail && data.redirectTo) {
                    location.href = data.redirectTo;
                }
                if (data.success) toast.success(`${data.message}     <strong><a class="text-body" href="./ordering/cart">View cart</a></strong>`);
                if (refresh) return cart.refresh();
            });
    },
};

export default cart;
